import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserId } from 'store/session/selectors';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { CreateAppointmentForm } from 'components/Appointments/CreateAppointmentForm';
import { AppointmentFormData } from 'types/appointment';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useNotifications } from 'hooks/useNotifications';
import { createUserAppointment } from 'services/appointmentService';
import { PATH } from 'routes/path';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const CreateAppointmentPage = () => {
    const userId = useSelector(getUserId);
    const [isLoading, setIsLoading] = useState(false);

    const notifications = useNotifications();
    const navigate = useNavigate();

    const createHandler = (form: AppointmentFormData) => {
        setIsLoading(true);
        createUserAppointment(form)
            .then(() => {
                notifications.show({ message: 'Appointment successfully created' });
                navigate(PATH.APPOINTMENTS);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Appointment" sx={cardStyles}>
                <CreateAppointmentForm onCreate={createHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
